import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Card,
    Typography,
    Space,
    Button,
    Row,
    Col,
    Avatar,
    Badge,
    Table,
    Modal,
    Spin,
    Tag,
    Descriptions,
    Empty,
    Select,
    Input,
    DatePicker
} from 'antd';
import {
    FileTextOutlined,
    ShoppingOutlined,
    UserOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
    MailOutlined,
    PhoneOutlined,
    BankOutlined,
    TeamOutlined,
    IdcardOutlined,
    InfoCircleOutlined,
    DollarOutlined,
    WarningOutlined,
    BookOutlined,
    SearchOutlined,
    CameraOutlined
} from '@ant-design/icons';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { API_BASE_URL } from '../../utils/config';
import { formatMoney } from '../../utils/currency';
import { trIncludes } from '../../utils/trText';
import axios from 'axios';
import FormikForm from '../form/FormikForm';
import { usePersonelFoto } from './PersonelFotoKirp';
import GirisCikisTakvimi from '../profil/GirisCikisTakvimi';
import dayjs from 'dayjs';
import './Personel.css';

const { Title, Text } = Typography;

const decodeHtmlEntities = (text) => {
    if (typeof text !== 'string' || !text) return text;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};

const PersonelPage = () => {
    const { user, getAuthHeaders } = useAuth();
    const { darkMode } = useTheme();
    const navigate = useNavigate();
    const { kullaniciNo } = useParams();
    const [loading, setLoading] = useState(true);
    const [formModalOpen, setFormModalOpen] = useState(false);
    const [currentFormId, setCurrentFormId] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [formTableName, setFormTableName] = useState('');
    const [formUniqueField, setFormUniqueField] = useState('');
    const [currentUniqueValue, setCurrentUniqueValue] = useState(null);
    const [formExtraData, setFormExtraData] = useState({});
    const [profileData, setProfileData] = useState(null);
    const [documentsModalOpen, setDocumentsModalOpen] = useState(false);
    const [assignedItemsModalOpen, setAssignedItemsModalOpen] = useState(false);
    const [jobDescriptionModalOpen, setJobDescriptionModalOpen] = useState(false);
    const [leavesModalOpen, setLeavesModalOpen] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [assignedItems, setAssignedItems] = useState([]);
    const [jobDescription, setJobDescription] = useState(null);
    const [leaves, setLeaves] = useState([]);
    const [accident, setAccident] = useState([]);
    const [selectedModal, setSelectedModal] = useState(null);
    const [documentsSearchText, setDocumentsSearchText] = useState('');
    const [assignedItemsSearchText, setAssignedItemsSearchText] = useState('');
    const [leavesSearchText, setLeavesSearchText] = useState('');
    const [accidentSearchText, setAccidentSearchText] = useState('');
    const [payments, setPayments] = useState([]);
    const [paymentDateStart, setPaymentDateStart] = useState(dayjs('2018-01-01'));
    const [paymentDateEnd, setPaymentDateEnd] = useState(dayjs().add(1, 'year'));
    const [paymentsLoading, setPaymentsLoading] = useState(false);
    const [paymentSearchText, setPaymentSearchText] = useState('');
    const [educations, setEducations] = useState([]);
    const [educationSearchText, setEducationSearchText] = useState('');
    const [career, setCareer] = useState([]);
    const [careerPosition, setCareerPosition] = useState(null);
    const [careerSearchText, setCareerSearchText] = useState('');
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const [careerModalOpen, setCareerModalOpen] = useState(false);
    const [personalModalOpen, setPersonalModalOpen] = useState(false);
    const [digerModalOpen, setDigerModalOpen] = useState(false);
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [accidentModalOpen, setAccidentModalOpen] = useState(false);
    const [educationModalOpen, setEducationModalOpen] = useState(false);
    const [egitimFormEgitim, setEgitimFormEgitim] = useState('');
    const [egitimFormTamamlanmaTarihi, setEgitimFormTamamlanmaTarihi] = useState(null);
    const [egitimFormAciklama, setEgitimFormAciklama] = useState('');
    const [egitimFormDurumu, setEgitimFormDurumu] = useState('2');
    const [egitimFormDegerlendirme, setEgitimFormDegerlendirme] = useState('0');
    const [egitimFormSil, setEgitimFormSil] = useState('0');
    const [fotoSurum, setFotoSurum] = useState(null);
    const { yetkili: fotoYetkisi, sec: fotoSec, pencere: fotoPenceresi } = usePersonelFoto(() => setFotoSurum(Date.now()));

    const PP_BASE_URL = 'https://dosya.atmturkiye.com';
    const BUCKET_NAME = 'atmpoint';
    const FOLDER_PATH = 'personel';

    const generateLogoUrl = (kullaniciNo) => {
        console.log("Kullanıcı", kullaniciNo);
        if (!kullaniciNo) return null;
        return `${PP_BASE_URL}/${BUCKET_NAME}/${FOLDER_PATH}%2F${kullaniciNo}.jpg${fotoSurum ? `?v=${fotoSurum}` : ''}`;
    };

    // Personel fotoğrafı (03.11.2026): Fedora avatarı MinIO personel/<no>.jpg'den okur; eskiden yalnız PHP diskine
    // konuyordu ve buraya hiç gelmiyordu. Yükleme yalnız İK + BT (PersonelFotoKirp.jsx › usePersonelFoto).

    useEffect(() => {
        if (kullaniciNo) {
            fetchProfileData();
        }
    }, [kullaniciNo]);

    const formatDate = (dateString) => {
        if (!dateString || dateString === '0000-00-00' || dateString === null) return null;
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatPhone = (phone) => {
        if (!phone) return '';
        const cleaned = phone.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `0 ${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6, 8)} ${cleaned.substring(8, 10)}`;
        }
        return phone;
    };

    const calculateAge = (birthDate) => {
        if (!birthDate || birthDate === '0000-00-00' || birthDate === null) return null;
        const today = new Date();
        const birth = new Date(birthDate);
        if (isNaN(birth.getTime())) return null;
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    };

    const calculateWorkDuration = (startDate) => {
        if (!startDate || startDate === '0000-00-00' || startDate === null) return null;
        const today = new Date();
        const start = new Date(startDate);
        if (isNaN(start.getTime())) return null;

        let years = today.getFullYear() - start.getFullYear();
        let months = today.getMonth() - start.getMonth();
        let days = today.getDate() - start.getDate();

        if (days < 0) {
            months--;
            const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
            days += lastMonth.getDate();
        }

        if (months < 0) {
            years--;
            months += 12;
        }

        const parts = [];
        if (years > 0) parts.push(`${years} yıl`);
        if (months > 0) parts.push(`${months} ay`);
        if (days > 0) parts.push(`${days} gün`);

        return parts.length > 0 ? parts.join(' ') : '0 gün';
    };

    const fetchProfileData = async () => {
        try {
            setLoading(true);
            const userId = kullaniciNo;
            const userResponse = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-kullanici`,
                { params: { id: userId } },
                { headers: getAuthHeaders() }
            );
            const userData = Array.isArray(userResponse.data) && userResponse.data.length > 0
                ? userResponse.data[0]
                : null;
            if (userData) {
                const birthDate = formatDate(userData.dogun_tarihi);
                const startDate = formatDate(userData.ise_giris_tarihi);
                const endDate = formatDate(userData.is_cikis_tarihi);
                const age = calculateAge(userData.dogun_tarihi);
                const workDuration = calculateWorkDuration(userData.ise_giris_tarihi);

                setProfileData({
                    name: userData.ad_soyad || user?.ad_soyad || 'Kullanıcı',
                    birthDate: birthDate || 'Tanımsız',
                    age: age,
                    phone: formatPhone(userData.kul_tel) + (userData.dahili ? ` | Dahili: ${userData.dahili}` : ''),
                    email: userData.kul_mail || (user?.username ? `${user.username}@atmturkiye.com` : 'email@atmturkiye.com'),
                    startDate: startDate || 'Tanımsız',
                    workDuration: workDuration || '',
                    endDate: endDate,
                    company: userData.firma || 'Tanımsız',
                    department: userData.grup || 'Tanımsız',
                    pozisyon: userData.pozisyon,
                    pozisyon_id: userData.pozisyon_id
                });
            }

            const docsResponse = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-belge`,
                { params: { id: userId } },
                { headers: getAuthHeaders() }
            );
            const docsData = Array.isArray(docsResponse.data) ? docsResponse.data : [];

            const nameMap = {
                1: 'Fotoğraf',
                2: 'CV',
                3: 'Diploma',
                4: 'Sağlık Raporu',
                5: 'Nüfus Cüzdanı',
                6: 'Nüfus Kayıt Örneği',
                7: 'Kan Grubu',
                8: 'Ehliyet',
                9: 'İkametgah',
                10: 'Askerlik',
                11: 'Adli Sicil Kaydı',
                12: 'İş Başvuru Formu',
                13: 'İş Sözleşmesi',
                14: 'SGK İşe Giriş Bildirgesi',
                15: 'SGK İşten Ayrılış Bildirgesi',
                16: 'İmza Beyannamesi',
                17: 'KVKK Açık Rıza',
                99: 'Diğer'
            };

            let na = [1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 14, 15, 16];
            if (userData?.cinsiyet == 1) {
                if (userData.is_cikis_tarihi === '0000-00-00' || !userData.is_cikis_tarihi) {
                    na = [1, 2, 3, 4, 5, 6, 8, 9, 11, 12, 13, 14, 99];
                } else {
                    na = [1, 2, 3, 4, 5, 6, 8, 9, 11, 12, 13, 14, 15, 16];
                }
            } else {
                if (userData?.is_cikis_tarihi === '0000-00-00' || !userData?.is_cikis_tarihi) {
                    na = [1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 14, 99];
                } else {
                    na = [1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 14, 15, 16];
                }
            }

            const docsByType = {};
            docsData.forEach(doc => {
                const tip = doc['Evrak Tipi'];
                if (!docsByType[tip]) {
                    docsByType[tip] = [];
                }
                docsByType[tip].push(doc);
            });

            const docList = na.map(tip => ({
                name: nameMap[tip],
                status: !!docsByType[tip],
                files: docsByType[tip] || []
            }));
            setDocuments(docList);

            const zimmetResponse = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-zimmet`,
                { params: { id: userId } },
                { headers: getAuthHeaders() }
            );
            const zimmetData = Array.isArray(zimmetResponse.data) ? zimmetResponse.data : [];
            const items = zimmetData.map(item => ({
                key: item.key_zimmet || item.No,
                type: item.Tip || '',
                brand: item.Marka || '',
                detail: item['Seri Numara/IMEI/Hat/Plaka'] || '',
                date: item['Zimmet Tarihi'] || ''
            }));
            setAssignedItems(items);

            try {
                if (userData?.pozisyon_id) {
                    const jobResponse = await axios.post(
                        `${API_BASE_URL}/list/execute-query/profil-gorev`,
                        { params: { id: userData.pozisyon_id } },
                        { headers: getAuthHeaders() }
                    );
                    const jobData = Array.isArray(jobResponse.data) && jobResponse.data.length > 0
                        ? jobResponse.data[0]
                        : null;

                    if (jobData) {
                        setJobDescription({
                            code: jobData.kod || '',
                            description: jobData.aciklama || '',
                            name: jobData.ad || '',
                            responsibilities: jobData.gorev_tanimi || ''
                        });
                    }
                }
            } catch (error) {
                console.error('Görev tanımı yüklenirken hata:', error);
            }

            try {
                const leavesResponse = await axios.post(
                    `${API_BASE_URL}/list/execute-query/profil-izin`,
                    { params: { id: userId } },
                    { headers: getAuthHeaders() }
                );
                const leavesData = Array.isArray(leavesResponse.data) ? leavesResponse.data : [];

                const leavesList = leavesData.map((leave, index) => ({
                    key: leave.key_izinim || index,
                    name: leave['İsim Soyisim'] || '',
                    startDate: leave.Başlangıç || '',
                    endDate: leave.Bitiş || '',
                    hours: leave.Saatler || '',
                    reason: leave['İzin Sebebi'] || '',
                    type: leave['İzin Tipi'] || '',
                    startTime: leave['Başlangıç Saati'] || '',
                    endTime: leave['Bitiş Saati'] || '',
                    approval: leave.Onay || '',
                    requestDate: leave['Talep Tarihi'] || ''
                }));
                setLeaves(leavesList);
            } catch (error) {
                console.error('İzin verileri yüklenirken hata:', error);
                setLeaves([]);
            }

            try {
                const kazalarResponse = await axios.post(
                    `${API_BASE_URL}/list/execute-query/kazalar`,
                    { params: { id: userId } },
                    { headers: getAuthHeaders() }
                );
                const kazalarData = Array.isArray(kazalarResponse.data) ? kazalarResponse.data : [];

                const cezalarResponse = await axios.post(
                    `${API_BASE_URL}/list/execute-query/cezalar`,
                    { params: { id: userId } },
                    { headers: getAuthHeaders() }
                );
                const cezalarData = Array.isArray(cezalarResponse.data) ? cezalarResponse.data : [];

                const kazalarList = kazalarData.map((kaza, index) => ({
                    key: `kaza_${index}`,
                    tip: 'Kaza',
                    surucu: kaza['Kaza Sürücü'] || '',
                    plaka: kaza['Kaza Plaka'] || '',
                    tarih: kaza['Kaza Tarih'] || '',
                    beyan: kaza['Kaza Beyanı'] || '',
                    belgeNo: kaza['Kaza Belge No'] || '',
                    aciklama: kaza['Kaza Açıklama'] || '',
                    karsiPlaka: kaza['Karşı Araç Plaka'] || '',
                    karsiSurucu: kaza['Karşı Araç Sürücü'] || '',
                    karsiSigorta: kaza['Karşı Araç Sigorta'] || '',
                    kusur: kaza['Kaza Kusur'] || ''
                }));

                const cezalarList = cezalarData.map((ceza, index) => ({
                    key: `ceza_${index}`,
                    tip: 'Ceza',
                    surucu: ceza['Ceza Sürücü'] || '',
                    plaka: ceza['Ceza Plaka'] || '',
                    tarih: ceza['Ceza Tarih'] || '',
                    tutar: ceza['Ceza Tutar'] || '',
                    belgeNo: ceza['Ceza Belge No'] || '',
                    aciklama: ceza['Ceza Açıklama'] || '',
                    beyan: '',
                    karsiPlaka: '',
                    karsiSurucu: '',
                    karsiSigorta: '',
                    kusur: ''
                }));

                const combinedList = [...kazalarList, ...cezalarList];
                setAccident(combinedList);
            } catch (error) {
                console.error('Kaza/ceza verileri yüklenirken hata:', error);
                setAccident([]);
            }

        } catch (error) {
            console.error('Profil verileri yüklenirken hata:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenForm = (formId, title = 'Form', tableName = '', uniqueField = '', uniqueValue = null, extraData = {}, overrideFunction = null) => {
        setModalTitle(title);
        setCurrentFormId(formId);
        setFormTableName(tableName);
        setFormUniqueField(uniqueField);
        setCurrentUniqueValue(uniqueValue);
        setFormExtraData({
            ...extraData,
            ...(overrideFunction && { _override_function: overrideFunction })
        });
        setFormModalOpen(true);
    };

    const handleFormSuccess = () => {
        setFormModalOpen(false);
        setCurrentFormId(null);
        setFormTableName('');
        setFormUniqueField('');
        setCurrentUniqueValue(null);
        fetchProfileData();
    };

    const closeFormModal = () => {
        setFormModalOpen(false);
    };

    const handleViewFile = (file) => {
        if (!file) return;
        if (file.File && file.Dir) {
            const fileUrl = `${PP_BASE_URL}/${BUCKET_NAME}/${file.File}`;
            window.open(fileUrl, '_blank');
        } else {
            console.log('Dosya bilgisi bulunamadı:', file);
        }
    };

    const leavesColumns = [
        {
            title: 'İsim Soyisim',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Başlangıç',
            dataIndex: 'startDate',
            key: 'startDate',
            render: (text) => {
                if (!text) return '-';
                return formatDate(text);
            }
        },
        {
            title: 'Bitiş',
            dataIndex: 'endDate',
            key: 'endDate',
            render: (text) => {
                if (!text) return '-';
                return formatDate(text);
            }
        },
        {
            title: 'Saatler',
            dataIndex: 'hours',
            key: 'hours',
        },
        {
            title: 'İzin Sebebi',
            dataIndex: 'reason',
            key: 'reason',
        },
        {
            title: 'Onay',
            dataIndex: 'approval',
            key: 'approval',
            render: (text) => (
                <Tag color={text === 'Onaylandı' ? 'green' : 'red'}>
                    {text}
                </Tag>
            )
        },
        {
            title: 'Talep Tarihi',
            dataIndex: 'requestDate',
            key: 'requestDate',
        },
        {
            title: 'Dilekçe',
            dataIndex: 'petition',
            key: 'petition',
            render: (text, record) => (
                <Button
                    type="link"
                    size="small"
                    onClick={() => navigate(`/dilekce/${record.key}`)}
                >
                    {text || 'Görüntüle'}
                </Button>
            )
        }
    ];

    const accidentColumns = [
        {
            title: 'Tip',
            dataIndex: 'tip',
            key: 'tip',
            width: 80,
            render: (text) => (
                <Tag color={text === 'Kaza' ? 'red' : 'orange'}>
                    {text}
                </Tag>
            )
        },
        {
            title: 'Sürücü',
            dataIndex: 'surucu',
            key: 'surucu',
        },
        {
            title: 'Plaka',
            dataIndex: 'plaka',
            key: 'plaka',
        },
        {
            title: 'Tarih',
            dataIndex: 'tarih',
            key: 'tarih',
            render: (text) => {
                if (!text) return '-';
                return formatDate(text);
            }
        },
        {
            title: 'Tutar',
            dataIndex: 'tutar',
            key: 'tutar',
            render: (text, record) => {
                if (record.tip === 'Ceza' && text) {
                    return formatMoney(text);
                }
                return '-';
            }
        },
        {
            title: 'Belge No',
            dataIndex: 'belgeNo',
            key: 'belgeNo',
        },
        {
            title: 'Açıklama',
            dataIndex: 'aciklama',
            key: 'aciklama',
            ellipsis: true,
        },
        {
            title: 'Kaza Beyanı',
            dataIndex: 'beyan',
            key: 'beyan',
            ellipsis: true,
            render: (text, record) => {
                if (record.tip === 'Kaza' && text) {
                    return text;
                }
                return '-';
            }
        },
        {
            title: 'Karşı Araç Plaka',
            dataIndex: 'karsiPlaka',
            key: 'karsiPlaka',
            render: (text, record) => {
                if (record.tip === 'Kaza' && text) {
                    return text;
                }
                return '-';
            }
        },
        {
            title: 'Karşı Araç Sürücü',
            dataIndex: 'karsiSurucu',
            key: 'karsiSurucu',
            render: (text, record) => {
                if (record.tip === 'Kaza' && text) {
                    return text;
                }
                return '-';
            }
        },
        {
            title: 'Kusur',
            dataIndex: 'kusur',
            key: 'kusur',
            render: (text, record) => {
                if (record.tip === 'Kaza' && text) {
                    return text;
                }
                return '-';
            }
        }
    ];

    const paymentColumns = [
        {
            title: 'Cari / Alacaklı',
            dataIndex: 'cariAdi',
            key: 'cariAdi',
            render: (text, record) => {
                if (text && text !== 'Tanımsız') {
                    return text;
                } else {
                    return `${record.firma || ''} / ${record.hesapSahibi || ''}`;
                }
            }
        },
        {
            title: 'Onaylandı',
            dataIndex: 'onaylandi',
            key: 'onaylandi',
        },
        {
            title: 'Durum',
            dataIndex: 'durum',
            key: 'durum',
            render: (text) => (
                <Tag color={text ? 'green' : 'orange'}>
                    {text ? 'Ödendi' : 'Bekliyor'}
                </Tag>
            )
        },
        {
            title: 'Tutar',
            dataIndex: 'tutar',
            key: 'tutar',
            align: 'right',
            render: (text) => text ? formatMoney(text) : formatMoney(0)
        },
        {
            title: 'Kalan',
            dataIndex: 'kalan',
            key: 'kalan',
            align: 'right',
            render: (text) => text ? formatMoney(text) : formatMoney(0)
        },
        {
            title: 'Ödenecek',
            dataIndex: 'odenecek',
            key: 'odenecek',
            align: 'right',
            render: (text) => text ? formatMoney(text) : formatMoney(0)
        },
        {
            title: 'Vade',
            dataIndex: 'vade',
            key: 'vade',
            render: (text) => {
                if (!text || text === '0000-00-00') return '-';
                return formatDate(text);
            }
        },
        {
            title: 'Erteleme',
            dataIndex: 'erteleme',
            key: 'erteleme',
            render: (text) => {
                if (!text || text === '0000-00-00') return 'Yok';
                return formatDate(text);
            }
        },
        {
            title: 'Ekleyen',
            dataIndex: 'ekleyen',
            key: 'ekleyen',
        },
        {
            title: 'Onaylayan',
            dataIndex: 'onaylayan',
            key: 'onaylayan',
        },
        {
            title: 'Açıklama',
            dataIndex: 'aciklama',
            key: 'aciklama',
        },
        {
            title: 'Düzenle',
            key: 'action',
            render: (text, record) => (
                <Button
                    type="primary"
                    size="small"
                    disabled={record.durum && user?.kullanici_no !== '57'}
                    onClick={() => handleOpenForm(
                        241,
                        'Ödeme Kaydı Düzenle',
                        'odm_taksit',
                        'id',
                        record.id,
                        {
                            alacakli_pass: record.cariAdi !== 'Tanımsız' ? record.cariAdi : `${record.firma} / ${record.hesapSahibi}`,
                            tutar: record.tutar,
                            kalan: record.kalan,
                            odenecek: record.odenecek,
                            vade: record.vade,
                            onay: record.onaySelect,
                            erteleme: record.erteleme !== '0000-00-00' ? record.erteleme : '',
                            aciklama: record.aciklama
                        },
                        {
                            ekleyen: user?.kullanici_no || null,
                            eklenme_tarihi: new Date().toISOString().split('T')[0]
                        },
                        'Update'
                    )}
                >
                    Düzenle
                </Button>
            )
        }
    ];

    const educationColumns = [
        {
            title: 'Eğitim Adı',
            dataIndex: 'egitimAdi',
            key: 'egitimAdi',
        },
        {
            title: 'Eğitim Durumu',
            dataIndex: 'egitimDurumu',
            key: 'egitimDurumu',
            render: (text, record) => {
                const colorMap = {
                    'Başlamadı': 'default',
                    'Devam Ediyor': 'processing',
                    'Tamamlandı': 'success',
                    'İptal Edildi': 'error'
                };
                return (
                    <Tag color={colorMap[text] || 'default'}>
                        {text}
                    </Tag>
                );
            }
        },
        {
            title: 'Tamamlanma Tarihi',
            dataIndex: 'tamamlanmaTarihi',
            key: 'tamamlanmaTarihi',
            render: (text) => {
                if (!text || text === '0000-00-00') return '-';
                return formatDate(text);
            }
        },
        {
            title: 'Değerlendirme',
            dataIndex: 'degerlendirme',
            key: 'degerlendirme',
            ellipsis: true,
        },
        {
            title: 'İşlem',
            key: 'action',
            render: (text, record) => (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => handleOpenForm(
                        171,
                        'Eğitim Düzenle',
                        'kullanicilar_kariyer',
                        'id',
                        record.id,
                        {
                            ekleyen: user?.kullanici_no || null,
                            eklenmeTarihi: new Date().toISOString().split('T')[0]
                        },
                        'Insert'
                    )}
                >
                    Düzenle
                </Button>
            )
        }
    ];

    const careerEducationColumns = [
        {
            title: 'Eğitim Adı',
            dataIndex: 'egitimAdi',
            key: 'egitimAdi',
            align: 'center',
        },
        {
            title: 'Eğitim Durumu',
            dataIndex: 'egitimDurumu',
            key: 'egitimDurumu',
            align: 'center',
        },
        {
            title: 'Tamamlanma Tarihi',
            dataIndex: 'tamamlanmaTarihi',
            key: 'tamamlanmaTarihi',
            align: 'center',
            render: (text) => text ? formatDate(text) : '',
        },
        {
            title: 'Değerlendirme',
            dataIndex: 'degerlendirme',
            key: 'degerlendirme',
            align: 'center',
        },
        {
            title: 'İşlem',
            key: 'action',
            align: 'center',
            render: (text, record) => (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => handleOpenForm(
                        171,
                        'Eğitim Düzenle',
                        'kullanicilar_egitim',
                        'id',
                        record.id,
                        {
                            ekleyen: user?.kullanici_no || null,
                            eklenmeTarihi: new Date().toISOString().split('T')[0]
                        },
                        'Update'
                    )}
                >
                    Düzenle
                </Button>
            )
        }
    ];

    const assignedItemsColumns = [
        {
            title: 'Tip',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'Marka',
            dataIndex: 'brand',
            key: 'brand',
        },
        {
            title: 'Seri Numara/IMEI/Hat/Plaka',
            dataIndex: 'detail',
            key: 'detail',
        },
        {
            title: 'Zimmet Tarihi',
            dataIndex: 'date',
            key: 'date',
            render: (text) => {
                if (!text) return '-';
                return formatDate(text);
            }
        }
    ];

    const modalOptions = [
        {
            value: 'genel',
            label: 'Genel',
            icon: <UserOutlined />,
            modalState: infoModalOpen,
            setModalState: setInfoModalOpen
        },
        {
            value: 'kariyer',
            label: 'Kariyer',
            icon: <UserOutlined />,
            modalState: careerModalOpen,
            setModalState: setCareerModalOpen
        },
        {
            value: 'personal',
            label: 'Kişisel Bilgiler',
            icon: <UserOutlined />,
            modalState: personalModalOpen,
            setModalState: setPersonalModalOpen
        },
        {
            value: 'diger',
            label: 'Diğer',
            icon: <InfoCircleOutlined />,
            modalState: digerModalOpen,
            setModalState: setDigerModalOpen
        },
        {
            value: 'jobDescription',
            label: 'Görev Tanımı',
            icon: <FileTextOutlined />,
            modalState: jobDescriptionModalOpen,
            setModalState: setJobDescriptionModalOpen
        },
        {
            value: 'leaves',
            label: 'İzinler',
            icon: <CalendarOutlined />,
            modalState: leavesModalOpen,
            setModalState: setLeavesModalOpen
        },
        {
            value: 'payment',
            label: 'Ödemeler',
            icon: <DollarOutlined />,
            modalState: paymentModalOpen,
            setModalState: setPaymentModalOpen
        },
        {
            value: 'assignedItems',
            label: 'Zimmet Edilen Eşyalar',
            icon: <ShoppingOutlined />,
            modalState: assignedItemsModalOpen,
            setModalState: setAssignedItemsModalOpen
        },
        {
            value: 'accident',
            label: 'Kaza/Cezalar',
            icon: <WarningOutlined />,
            modalState: accidentModalOpen,
            setModalState: setAccidentModalOpen
        },
        {
            value: 'documents',
            label: 'Dosyalar',
            icon: <FileTextOutlined />,
            modalState: documentsModalOpen,
            setModalState: setDocumentsModalOpen
        },
        {
            value: 'education',
            label: 'Eğitim',
            icon: <BookOutlined />,
            modalState: educationModalOpen,
            setModalState: setEducationModalOpen
        }
    ];

    const fetchPayments = async (dateStart, dateEnd) => {
        try {
            setPaymentsLoading(true);
            const userId = kullaniciNo;
            const response = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-odemeler`,
                {
                    params: {
                        id: userId,
                        tarih: dateStart,
                        tarih2: dateEnd
                    }
                },
                { headers: getAuthHeaders() }
            );
            const paymentsData = Array.isArray(response.data) ? response.data : [];
            const paymentsList = paymentsData.map((payment, index) => ({
                key: payment.id || index,
                cariAdi: payment['Cari Adı'] || '',
                firma: payment['Firma'] || '',
                hesapSahibi: payment['Hesap Sahibi'] || '',
                tutar: payment['tutar'] || 0,
                kalan: payment['Kalan'] || 0,
                odenecek: payment['Ödenecek'] || 0,
                vade: payment['Vade'] || '',
                durum: payment['Durum'] || 0,
                onaySelect: payment['OnaySelect'] || 0,
                onaylayan: payment['Onaylayan'] || '',
                erteleme: payment['Erteleme'] || '',
                aciklama: payment['aciklama-pop'] || '',
                id: payment['id'] || null,
                ekleyen: payment['ekleyen'] || '',
                onaylandi: payment['Onaylandi'] || 'Hayır'
            }));

            setPayments(paymentsList);
        } catch (error) {
            console.error('Ödeme verileri yüklenirken hata:', error);
            setPayments([]);
        } finally {
            setPaymentsLoading(false);
        }
    };

    const fetchEducations = async () => {
        try {
            const userId = kullaniciNo;
            const response = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-egitimler`,
                { params: { id: userId } },
                { headers: getAuthHeaders() }
            );
            const educationsData = Array.isArray(response.data) ? response.data : [];
            const egitimDurumu = {
                0: 'Başlamadı',
                1: 'Devam Ediyor',
                2: 'Tamamlandı',
                3: 'İptal Edildi'
            };
            const educationsList = educationsData.map((education, index) => ({
                key: education.key_egitim || index,
                egitimAdi: education.egitim_adi || '',
                egitimDurumu: education.egitim_durumu !== null && education.egitim_durumu !== undefined
                    ? egitimDurumu[education.egitim_durumu] || 'Bilinmiyor'
                    : 'Bilinmiyor',
                egitimDurumuValue: education.egitim_durumu,
                tamamlanmaTarihi: education.tamamlanma_tarihi || '',
                degerlendirme: education.degerlendirme || '',
                id: education.key_egitim || null
            }));
            setEducations(educationsList);
        } catch (error) {
            console.error('Eğitim verileri yüklenirken hata:', error);
            setEducations([]);
        }
    };

    const handleModalSelect = (value) => {
        if (value === 'genel') {
            console.log('genel');
            setSelectedModal(value);
            handleOpenForm(166, 'Genel Bilgiler', 'kullanicilar', 'kullanici_no', user?.kullanici_no, {
                guncelleyen: user?.kullanici_no ?? null,
                eklenme_tarihi: new Date().toISOString().split('T')[0]
            }, 'Update');
            return;
        } else if (value === 'kariyer') {
            setSelectedModal(value);
            handleOpenForm(167, 'Eğitim Ekle ', 'kullanicilar_kariyer', 'kullanici_no', user?.kullanici_no, {
                ekleyen: user?.kullanici_no ?? null,
                eklenmeTarihi: new Date().toISOString().split('T')[0]
            }, 'Update');
            return;
        }  else if (value === 'personal') {
            setSelectedModal(value);
            handleOpenForm(168, 'Kişisel Bilgiler ', 'kullanicilar', 'kullanici_no', user?.kullanici_no, {
                guncelleyen: user?.kullanici_no ?? null,
                eklenme_tarihi: new Date().toISOString().split('T')[0]
            }, 'Update');
            return;
        } else if (value === 'diger') {
            setSelectedModal(value);
            handleOpenForm(169, 'Diğer', 'kullanicilar_diger', 'kullanici_no', user?.kullanici_no, {
                ekleyen: user?.kullanici_no ?? null,
            }, 'Update');
            return;
        } else if (value === 'education') {
            setSelectedModal(value);
            handleOpenForm(171, 'Eğitim Bilgileri ', 'kullanicilar_egitim', 'kullanici_no', user?.kullanici_no, {
                ekleyen: user?.kullanici_no ?? null,
                eklenmeTarihi: new Date().toISOString().split('T')[0]
            }, 'Update');
            return;
        }
        setSelectedModal(value);
        const selectedOption = modalOptions.find(opt => opt.value === value);
        if (selectedOption) {
            selectedOption.setModalState(true);
            if (value === 'payment') {
                fetchPayments(
                    paymentDateStart.format('YYYY-MM-DD'),
                    paymentDateEnd.format('YYYY-MM-DD')
                );
            }
            if (value === 'education') {
                fetchEducations();
            }
            if (value === 'kariyer') {
                fetchCareer();
                fetchEducations();
            }
        }
    };

    const fetchCareer = async () => {
        try {
            const userId = kullaniciNo;
            const positionResponse = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-kariyer`,
                { params: { id: userId } },
                { headers: getAuthHeaders() }
            );
            const positionData = Array.isArray(positionResponse.data) && positionResponse.data.length > 0
                ? positionResponse.data[0]
                : null;

            if (positionData) {
                setCareerPosition({
                    iseGirisTarihi: positionData.ise_giris_tarihi || '',
                    isCikisTarihi: positionData.is_cikis_tarihi || '',
                    calismaSekli: positionData.calisma_sekli || '',
                    firma: positionData.firma || '',
                    grup: positionData.grup || '',
                    pozisyon: positionData.pozisyon || ''
                });
            }

            const educationResponse = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-kariyer-egitim`,
                { params: { id: userId } },
                { headers: getAuthHeaders() }
            );
            const educationData = Array.isArray(educationResponse.data) ? educationResponse.data : [];

            const ogrenimDurumu = {
                0: 'Öğrenci',
                1: 'Mezun',
                2: 'Yarıda Bıraktı'
            };

            const ogrenimSeviyesi = {
                0: 'İlkokul',
                1: 'Ortaokul',
                2: 'Lise',
                3: 'Ön Lisans',
                4: 'Lisans',
                5: 'Yüksek Lisans',
                6: 'Doktora'
            };

            const careerList = educationData.map((edu, index) => ({
                key: edu.id || index,
                egitimDurumu: edu.egitim_durumu !== null && edu.egitim_durumu !== undefined
                    ? ogrenimDurumu[edu.egitim_durumu] || 'Bilinmiyor'
                    : 'Bilinmiyor',
                egitimSeviyesi: edu.egitim_seviyesi !== null && edu.egitim_seviyesi !== undefined
                    ? ogrenimSeviyesi[edu.egitim_seviyesi] || 'Bilinmiyor'
                    : 'Bilinmiyor',
                kurumIsmi: edu.kurum_ismi || '',
                bolum: edu.bolum || '',
                id: edu.id || null
            }));

            setCareer(careerList);
        } catch (error) {
            console.error('Kariyer verileri yüklenirken hata:', error);
            setCareer([]);
            setCareerPosition(null);
        }
    };

    const handleModalClose = (modalType) => {
        const selectedOption = modalOptions.find(opt => opt.value === modalType);
        if (selectedOption) {
            selectedOption.setModalState(false);
        }
        setSelectedModal(null);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div className={`profil-container ${darkMode ? 'dark' : ''}`}>
            {fotoPenceresi}
            <Row gutter={[24, 24]}>
                {/* Sol Kolon */}
                <Col xs={24} lg={8}>
                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                        {/* Profil Bilgileri */}
                        <Card className="profil-card">
                            <div className="profil-header">
                                <div className="pf-avatar">
                                    <Avatar
                                        size={200}
                                        src={generateLogoUrl(kullaniciNo)}
                                        icon={<UserOutlined />}
                                        className="profil-avatar"
                                    />
                                    {fotoYetkisi && (
                                        <Button
                                            type="primary"
                                            shape="circle"
                                            icon={<CameraOutlined />}
                                            className="pf-degistir"
                                            title="Fotoğrafı değiştir"
                                            onClick={() => fotoSec(kullaniciNo)}
                                        />
                                    )}
                                </div>
                                <Title level={2} className="profil-name">
                                    {profileData?.name || user?.ad_soyad || 'Kullanıcı'}
                                </Title>
                            </div>
                        </Card>

                        {/* Modal Seçim Dropdown */}
                        <Card className="profil-card">
                            <Title level={5} style={{ marginBottom: 16 }}>Detaylar</Title>
                            <Select
                                placeholder="Bir seçenek seçin..."
                                style={{ width: '100%' }}
                                value={selectedModal}
                                onChange={handleModalSelect}
                                size="large"
                                showSearch
                                filterOption={(input, option) => {
                                    const label = modalOptions.find(opt => opt.value === option.value)?.label || '';
                                    return trIncludes(label, input);
                                }}
                            >
                                {modalOptions.map(option => (
                                    <Select.Option key={option.value} value={option.value} label={option.label}>
                                        <Space>
                                            {option.icon}
                                            <span>{option.label}</span>
                                        </Space>
                                    </Select.Option>
                                ))}
                            </Select>
                        </Card>
                    </Space>
                </Col>

                {/* Sağ Kolon */}
                <Col xs={24} lg={16}>
                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                        {/* Genel Bilgiler */}
                        <Card className="profil-card">
                            <Descriptions column={1} bordered size="small">
                                <Descriptions.Item label={<><ClockCircleOutlined /> İşe Giriş Tarihi</>}>
                                    {profileData?.startDate} {profileData?.workDuration && `(${profileData.workDuration})`}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><IdcardOutlined /> İş Çıkış Tarihi</>}>
                                    {profileData?.endDate || 'Halen Çalışıyor'}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><TeamOutlined /> Departman</>}>
                                    {profileData?.department}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><UserOutlined /> Pozisyon</>}>
                                    {profileData?.pozisyon}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><BankOutlined /> Firma</>}>
                                    {profileData?.company}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><PhoneOutlined /> Telefon</>}>
                                    {profileData?.phone}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><CalendarOutlined /> Doğum Tarihi</>}>
                                    {profileData?.birthDate} {profileData?.age && `(${profileData.age} yaşında)`}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><MailOutlined /> E-Posta</>}>
                                    {profileData?.email}
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>

                        {/* Giriş-Çıkış Takvimi (Profil ile ortak bileşen) */}
                        <GirisCikisTakvimi kullaniciNo={kullaniciNo} izinler={leaves} />
                    </Space>
                </Col>
            </Row>

            {/* Belgeler Modal */}
            <Modal
                title="İş İçin Gerekli Belgeler"
                open={documentsModalOpen}
                onCancel={() => {
                    handleModalClose('documents');
                    setDocumentsSearchText('');
                }}
                footer={null}
                width={600}
                className={darkMode ? 'dark-modal' : ''}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <Input
                        placeholder="Belge ara..."
                        prefix={<SearchOutlined />}
                        value={documentsSearchText}
                        onChange={(e) => setDocumentsSearchText(e.target.value)}
                        allowClear
                        style={{ marginBottom: 8 }}
                    />
                    {documents.length > 0 ? (
                        documents.filter(doc =>
                            trIncludes(doc.name, documentsSearchText)
                        ).length > 0 ? (
                            documents.filter(doc =>
                                trIncludes(doc.name, documentsSearchText)
                            ).map((doc, index) => (
                                <div key={index} className="document-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                    <Space>
                                        {doc.status ? (
                                            <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 20 }} />
                                        ) : (
                                            <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: 20 }} />
                                        )}
                                        <Text style={{ color: darkMode ? '#fff' : undefined }}>{doc.name}</Text>
                                        {doc.files && doc.files.length > 0 && (
                                            <Text type="secondary" style={{ marginLeft: 8, color: darkMode ? 'rgba(255, 255, 255, 0.65)' : undefined }}>
                                                ({doc.files.length} dosya)
                                            </Text>
                                        )}
                                    </Space>
                                    {doc.files && doc.files.length > 0 && (
                                        <Space>
                                            <Button type="default" size="small" onClick={() => { handleOpenForm(193, 'Özlük Belgeleri', 'ozluk', 'id', doc.files[0].ID, { user_id: user?.kullanici_no }, "Update") }}>Düzenle</Button>
                                            <Button type="link" size="small" onClick={() => handleViewFile(doc.files[0])}>Görüntüle</Button>
                                        </Space>
                                    )}
                                </div>
                            ))
                        ) : (
                            <Empty description="Arama sonucu bulunamadı" />
                        )
                    ) : (
                        <Empty description="Belge bulunamadı" />
                    )}
                </Space>
            </Modal>

            {/* Zimmet Edilen Eşyalar Modal */}
            <Modal
                title="Zimmet Edilen Eşyalar"
                open={assignedItemsModalOpen}
                onCancel={() => {
                    handleModalClose('assignedItems');
                    setAssignedItemsSearchText('');
                }}
                footer={null}
                width={800}
                className={darkMode ? 'dark-modal' : ''}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <Input
                        placeholder="Ara (Tip, Marka, Seri No, Plaka)..."
                        prefix={<SearchOutlined />}
                        value={assignedItemsSearchText}
                        onChange={(e) => setAssignedItemsSearchText(e.target.value)}
                        allowClear
                    />
                    {assignedItems.filter(item => {
                        return (
                            trIncludes(item.type, assignedItemsSearchText) ||
                            trIncludes(item.brand, assignedItemsSearchText) ||
                            trIncludes(item.detail, assignedItemsSearchText) ||
                            trIncludes(item.date, assignedItemsSearchText)
                        );
                    }).length > 0 ? (
                        <Table
                            columns={assignedItemsColumns}
                            scroll={{ x: 'max-content' }}
                            dataSource={assignedItems.filter(item => {
                                return (
                                    trIncludes(item.type, assignedItemsSearchText) ||
                                    trIncludes(item.brand, assignedItemsSearchText) ||
                                    trIncludes(item.detail, assignedItemsSearchText) ||
                                    trIncludes(item.date, assignedItemsSearchText)
                                );
                            })}
                            pagination={false}
                            size="small"
                            rowKey="key"
                            className={darkMode ? 'dark-table' : ''}
                        />
                    ) : (
                        <Empty description="Zimmet edilen eşya bulunamadı" />
                    )}
                </Space>
            </Modal>

            {/* Görev Tanımı Modal */}
            <Modal
                title="Görev Tanımı"
                open={jobDescriptionModalOpen}
                onCancel={() => handleModalClose('jobDescription')}
                footer={null}
                width={800}
                className={darkMode ? 'dark-modal' : ''}
            >
                {jobDescription ? (
                    <Space direction="vertical" style={{ width: '100%' }} size="large">
                        <div>
                            <Text strong style={{ color: darkMode ? '#fff' : undefined }}>Kod: </Text>
                            <Text style={{ color: darkMode ? '#fff' : undefined }}>{jobDescription.code}</Text>
                        </div>
                        <div>
                            <Text strong style={{ color: darkMode ? '#fff' : undefined }}>Açıklama: </Text>
                            <Text style={{ color: darkMode ? '#fff' : undefined }}>{jobDescription.description}</Text>
                        </div>
                        {jobDescription.responsibilities && (
                            <div>
                                <Text strong>Görev ve Sorumluluklar:</Text>
                                <div
                                    style={{
                                        marginTop: 8,
                                        padding: 16,
                                        backgroundColor: darkMode ? '#2a2a2a' : '#f5f5f5',
                                        borderRadius: 4,
                                        color: darkMode ? '#fff' : '#000'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(jobDescription.responsibilities) }}
                                />
                            </div>
                        )}
                    </Space>
                ) : (
                    <Empty description="Görev tanımı bulunamadı" />
                )}
            </Modal>

            {/* İzinler Modal */}
            <Modal
                title="İzinler"
                open={leavesModalOpen}
                onCancel={() => {
                    handleModalClose('leaves');
                    setLeavesSearchText('');
                }}
                footer={null}
                width={1000}
                className={darkMode ? 'dark-modal' : ''}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <Input
                        placeholder="Ara (İsim, Tarih, Sebep, Onay)..."
                        prefix={<SearchOutlined />}
                        value={leavesSearchText}
                        onChange={(e) => setLeavesSearchText(e.target.value)}
                        allowClear
                    />
                    {leaves.filter(leave => {
                        return (
                            trIncludes(leave.name, leavesSearchText) ||
                            trIncludes(leave.startDate, leavesSearchText) ||
                            trIncludes(leave.endDate, leavesSearchText) ||
                            trIncludes(leave.reason, leavesSearchText) ||
                            trIncludes(leave.approval, leavesSearchText) ||
                            trIncludes(leave.requestDate, leavesSearchText)
                        );
                    }).length > 0 ? (
                        <Table
                            columns={leavesColumns}
                            scroll={{ x: 'max-content' }}
                            dataSource={leaves.filter(leave => {
                                return (
                                    trIncludes(leave.name, leavesSearchText) ||
                                    trIncludes(leave.startDate, leavesSearchText) ||
                                    trIncludes(leave.endDate, leavesSearchText) ||
                                    trIncludes(leave.reason, leavesSearchText) ||
                                    trIncludes(leave.approval, leavesSearchText) ||
                                    trIncludes(leave.requestDate, leavesSearchText)
                                );
                            })}
                            pagination={{ pageSize: 10 }}
                            size="small"
                            rowKey="key"
                            className={darkMode ? 'dark-table' : ''}
                        />
                    ) : (
                        <Empty description="İzin kaydı bulunamadı" />
                    )}
                </Space>
            </Modal>

            {/* Kaza/Cezalar Modal */}
            <Modal
                title="Kaza/Cezalar"
                open={accidentModalOpen}
                onCancel={() => {
                    handleModalClose('accident');
                    setAccidentSearchText('');
                }}
                footer={null}
                width={1000}
                className={darkMode ? 'dark-modal' : ''}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <Input
                        placeholder="Ara (Tip, Sürücü, Plaka, Tarih, Açıklama)..."
                        prefix={<SearchOutlined />}
                        value={accidentSearchText}
                        onChange={(e) => setAccidentSearchText(e.target.value)}
                        allowClear
                    />
                    {accident.filter(item => {
                        return (
                            trIncludes(item.tip, accidentSearchText) ||
                            trIncludes(item.surucu, accidentSearchText) ||
                            trIncludes(item.plaka, accidentSearchText) ||
                            trIncludes(item.tarih, accidentSearchText) ||
                            trIncludes(item.aciklama, accidentSearchText) ||
                            trIncludes(item.beyan, accidentSearchText) ||
                            trIncludes(item.belgeNo, accidentSearchText) ||
                            trIncludes(item.karsiPlaka, accidentSearchText) ||
                            trIncludes(item.kusur, accidentSearchText)
                        );
                    }).length > 0 ? (
                        <Table
                            columns={accidentColumns}
                            scroll={{ x: 'max-content' }}
                            dataSource={accident.filter(item => {
                                return (
                                    trIncludes(item.tip, accidentSearchText) ||
                                    trIncludes(item.surucu, accidentSearchText) ||
                                    trIncludes(item.plaka, accidentSearchText) ||
                                    trIncludes(item.tarih, accidentSearchText) ||
                                    trIncludes(item.aciklama, accidentSearchText) ||
                                    trIncludes(item.beyan, accidentSearchText) ||
                                    trIncludes(item.belgeNo, accidentSearchText) ||
                                    trIncludes(item.karsiPlaka, accidentSearchText) ||
                                    trIncludes(item.kusur, accidentSearchText)
                                );
                            })}
                            pagination={{ pageSize: 10 }}
                            size="small"
                            rowKey="key"
                            className={darkMode ? 'dark-table' : ''}
                        />
                    ) : (
                        <Empty description="Kaza/ceza kaydı bulunamadı" />
                    )}
                </Space>
            </Modal>

            {/* Eğitimler Modal */}
            <Modal
                title="Eğitim Bilgileri"
                open={educationModalOpen}
                onCancel={() => {
                    handleModalClose('education');
                    setEducationSearchText('');
                }}
                footer={null}
                width={1000}
                className={darkMode ? 'dark-modal' : ''}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    {/* Eğitim Bilgileri formu */}
                    <div style={{ marginBottom: 16 }}>
                        <Title level={5} style={{ marginBottom: 12 }}>Eğitim Bilgileri</Title>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Space direction="vertical" style={{ width: '100%' }} size="small">
                                    <div>
                                        <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Eğitim</Text>
                                        <Input
                                            placeholder="Eğitim"
                                            value={egitimFormEgitim}
                                            onChange={(e) => setEgitimFormEgitim(e.target.value)}
                                            allowClear
                                        />
                                    </div>
                                    <div>
                                        <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Tamamlanma Tarihi</Text>
                                        <DatePicker
                                            placeholder="gg.aa.yyyy"
                                            format="DD.MM.YYYY"
                                            value={egitimFormTamamlanmaTarihi}
                                            onChange={setEgitimFormTamamlanmaTarihi}
                                            allowClear
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                    <div>
                                        <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Açıklama</Text>
                                        <Input.TextArea
                                            placeholder="Açıklama"
                                            value={egitimFormAciklama}
                                            onChange={(e) => setEgitimFormAciklama(e.target.value)}
                                            rows={3}
                                            allowClear
                                        />
                                    </div>
                                </Space>
                            </Col>
                            <Col xs={24} md={12}>
                                <Space direction="vertical" style={{ width: '100%' }} size="small">
                                    <div>
                                        <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Durumu</Text>
                                        <Select
                                            placeholder="Durumu"
                                            value={egitimFormDurumu}
                                            onChange={setEgitimFormDurumu}
                                            style={{ width: '100%' }}
                                            options={[
                                                { value: '0', label: 'Başlamadı' },
                                                { value: '1', label: 'Devam Ediyor' },
                                                { value: '2', label: 'Beklemede' },
                                                { value: '3', label: 'Tamamlandı' },
                                                { value: '4', label: 'İptal Edildi' }
                                            ]}
                                        />
                                    </div>
                                    <div>
                                        <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Değerlendirme</Text>
                                        <Select
                                            placeholder="Değerlendirme"
                                            value={egitimFormDegerlendirme}
                                            onChange={setEgitimFormDegerlendirme}
                                            style={{ width: '100%' }}
                                            options={[0, 1, 2, 3, 4, 5].map(n => ({ value: String(n), label: String(n) }))}
                                        />
                                    </div>
                                    <div>
                                        <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Sil?</Text>
                                        <Select
                                            placeholder="Sil?"
                                            value={egitimFormSil}
                                            onChange={setEgitimFormSil}
                                            style={{ width: '100%' }}
                                            options={[
                                                { value: '0', label: 'Hayır' },
                                                { value: '1', label: 'Evet' }
                                            ]}
                                        />
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <div style={{ marginTop: 12, textAlign: 'center' }}>
                            <Button
                                type="primary"
                                size="large"
                                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', minWidth: 120 }}
                                onClick={() => handleOpenForm(
                                    170,
                                    'Eğitim Bilgileri',
                                    'egitimler',
                                    'id',
                                    null,
                                    {
                                        egitim_adi: egitimFormEgitim,
                                        tamamlanma_tarihi: egitimFormTamamlanmaTarihi ? dayjs(egitimFormTamamlanmaTarihi).format('YYYY-MM-DD') : '',
                                        aciklama: egitimFormAciklama,
                                        egitim_durumu: egitimFormDurumu,
                                        degerlendirme: egitimFormDegerlendirme,
                                        sil: egitimFormSil,
                                        kullanici_no: kullaniciNo,
                                        ekleyen: user?.kullanici_no || null,
                                        eklenmeTarihi: new Date().toISOString().split('T')[0]
                                    },
                                    'Insert'
                                )}
                            >
                                Kaydet
                            </Button>
                        </div>
                    </div>

                    <Space size="middle" wrap>
                        <Button
                            type="primary"
                            onClick={() => handleOpenForm(
                                170,
                                'Sistem Eğitimi Ekle',
                                'egitimler',
                                'id',
                                null,
                                {
                                    ekleyen: user?.kullanici_no || null,
                                    kullanici_no: kullaniciNo
                                },
                                'Insert'
                            )}
                        >
                            Sistem Eğitimi Ekle
                        </Button>
                    </Space>
                    <Input
                        placeholder="Ara (Eğitim Adı, Durum, Değerlendirme)..."
                        prefix={<SearchOutlined />}
                        value={educationSearchText}
                        onChange={(e) => setEducationSearchText(e.target.value)}
                        allowClear
                    />
                    {educations.filter(education => {
                        return (
                            trIncludes(education.egitimAdi, educationSearchText) ||
                            trIncludes(education.egitimDurumu, educationSearchText) ||
                            trIncludes(education.degerlendirme, educationSearchText)
                        );
                    }).length > 0 ? (
                        <Table
                            columns={educationColumns}
                            scroll={{ x: 'max-content' }}
                            dataSource={educations.filter(education => {
                                return (
                                    trIncludes(education.egitimAdi, educationSearchText) ||
                                    trIncludes(education.egitimDurumu, educationSearchText) ||
                                    trIncludes(education.degerlendirme, educationSearchText)
                                );
                            })}
                            pagination={{ pageSize: 10 }}
                            size="small"
                            rowKey="key"
                            className={darkMode ? 'dark-table' : ''}
                        />
                    ) : (
                        <Empty description="Eğitim kaydı bulunamadı" />
                    )}
                </Space>
            </Modal>

            {/* Kariyer Modal */}
            <Modal
                title="Kariyer Bilgileri"
                open={careerModalOpen}
                onCancel={() => {
                    handleModalClose('kariyer');
                    setCareerSearchText('');
                }}
                footer={null}
                width={1200}
                className={darkMode ? 'dark-modal' : ''}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="large">
                    <div>
                        <Button
                            type="primary"
                            onClick={() => handleOpenForm(
                                170,
                                'Sistem Eğitimi Ekle',
                                'egitimler',
                                'id',
                                null,
                                {
                                    ekleyen: user?.kullanici_no || null,
                                    eklenmeTarihi: new Date().toISOString().split('T')[0]
                                },
                                'Insert'
                            )}
                        >
                            Sistem Eğitimi Ekle
                        </Button>
                    </div>

                    {/* Eğitim Tablosu */}
                    <div>
                        {/* Eğitim Bilgileri formu - listelemeden önce */}
                        <div style={{ marginBottom: 24 }}>
                            <Row gutter={16}>
                                <Col xs={24} md={12}>
                                    <Space direction="vertical" style={{ width: '100%' }} size="small">
                                        <div>
                                            <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Eğitim</Text>
                                            <Input
                                                placeholder="Eğitim"
                                                value={egitimFormEgitim}
                                                onChange={(e) => setEgitimFormEgitim(e.target.value)}
                                                allowClear
                                            />
                                        </div>
                                        <div>
                                            <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Tamamlanma Tarihi</Text>
                                            <DatePicker
                                                placeholder="gg.aa.yyyy"
                                                format="DD.MM.YYYY"
                                                value={egitimFormTamamlanmaTarihi}
                                                onChange={setEgitimFormTamamlanmaTarihi}
                                                allowClear
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div>
                                            <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Açıklama</Text>
                                            <Input.TextArea
                                                placeholder="Açıklama"
                                                value={egitimFormAciklama}
                                                onChange={(e) => setEgitimFormAciklama(e.target.value)}
                                                rows={3}
                                                allowClear
                                            />
                                        </div>
                                    </Space>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Space direction="vertical" style={{ width: '100%' }} size="small">
                                        <div>
                                            <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Durumu</Text>
                                            <Select
                                                placeholder="Durumu"
                                                value={egitimFormDurumu}
                                                onChange={setEgitimFormDurumu}
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: '0', label: 'Başlamadı' },
                                                    { value: '1', label: 'Devam Ediyor' },
                                                    { value: '2', label: 'Beklemede' },
                                                    { value: '3', label: 'Tamamlandı' },
                                                    { value: '4', label: 'İptal Edildi' }
                                                ]}
                                            />
                                        </div>
                                        <div>
                                            <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Değerlendirme</Text>
                                            <Select
                                                placeholder="Değerlendirme"
                                                value={egitimFormDegerlendirme}
                                                onChange={setEgitimFormDegerlendirme}
                                                style={{ width: '100%' }}
                                                options={[0, 1, 2, 3, 4, 5].map(n => ({ value: String(n), label: String(n) }))}
                                            />
                                        </div>
                                        <div>
                                            <Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>Sil?</Text>
                                            <Select
                                                placeholder="Sil?"
                                                value={egitimFormSil}
                                                onChange={setEgitimFormSil}
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: '0', label: 'Hayır' },
                                                    { value: '1', label: 'Evet' }
                                                ]}
                                            />
                                        </div>
                                    </Space>
                                </Col>
                            </Row>
                            <div style={{ marginTop: 16, textAlign: 'center' }}>
                                <Button
                                    type="primary"
                                    size="large"
                                    style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', minWidth: 120 }}
                                    onClick={() => handleOpenForm(
                                        170,
                                        'Eğitim Bilgileri',
                                        'egitimler',
                                        'id',
                                        null,
                                        {
                                            egitim_adi: egitimFormEgitim,
                                            tamamlanma_tarihi: egitimFormTamamlanmaTarihi ? dayjs(egitimFormTamamlanmaTarihi).format('YYYY-MM-DD') : '',
                                            aciklama: egitimFormAciklama,
                                            egitim_durumu: egitimFormDurumu,
                                            degerlendirme: egitimFormDegerlendirme,
                                            sil: egitimFormSil,
                                            kullanici_no: kullaniciNo,
                                            ekleyen: user?.kullanici_no || null,
                                            eklenmeTarihi: new Date().toISOString().split('T')[0]
                                        },
                                        'Insert'
                                    )}
                                >
                                    Kaydet
                                </Button>
                            </div>
                        </div>
                        <Title level={4} style={{ marginBottom: 16 }}>Eğitimler</Title>
                        <Input
                            placeholder="Ara (Eğitim Adı, Eğitim Durumu, Tamamlanma Tarihi, Değerlendirme)..."
                            prefix={<SearchOutlined />}
                            value={careerSearchText}
                            onChange={(e) => setCareerSearchText(e.target.value)}
                            allowClear
                            style={{ marginBottom: 16 }}
                        />
                        {educations.filter(edu => {
                            return (
                                trIncludes(edu.egitimAdi, careerSearchText) ||
                                trIncludes(edu.egitimDurumu, careerSearchText) ||
                                trIncludes(edu.tamamlanmaTarihi, careerSearchText) ||
                                trIncludes(edu.degerlendirme, careerSearchText)
                            );
                        }).length > 0 ? (
                            <Table
                                columns={careerEducationColumns}
                                scroll={{ x: 'max-content' }}
                                dataSource={educations.filter(edu => {
                                    return (
                                        trIncludes(edu.egitimAdi, careerSearchText) ||
                                        trIncludes(edu.egitimDurumu, careerSearchText) ||
                                        trIncludes(edu.tamamlanmaTarihi, careerSearchText) ||
                                        trIncludes(edu.degerlendirme, careerSearchText)
                                    );
                                })}
                                pagination={false}
                                size="small"
                                rowKey="key"
                                className={`egitimler-table ${darkMode ? 'dark-table' : ''}`}
                                style={{ fontSize: 14 }}
                            />
                        ) : (
                            <Empty description="Eğitim kaydı bulunamadı" />
                        )}
                    </div>
                </Space>
            </Modal>

            {/* Ödemeler Modal */}
            <Modal
                title="Ödeme Bilgileri"
                open={paymentModalOpen}
                onCancel={() => {
                    handleModalClose('payment');
                    setPaymentSearchText('');
                }}
                footer={null}
                width={1400}
                className={darkMode ? 'dark-modal' : ''}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <div>
                        <Title level={4} style={{ marginBottom: 16 }}>Ödeme Talepleri</Title>
                        <Space size="middle" wrap>
                            <DatePicker
                                placeholder="Başlangıç Tarihi"
                                value={paymentDateStart}
                                onChange={(date) => setPaymentDateStart(date || dayjs('2018-01-01'))}
                                format="DD-MM-YYYY"
                            />
                            <DatePicker
                                placeholder="Bitiş Tarihi"
                                value={paymentDateEnd}
                                onChange={(date) => setPaymentDateEnd(date || dayjs().add(1, 'year'))}
                                format="DD-MM-YYYY"
                            />
                            <Button
                                type="primary"
                                onClick={() => fetchPayments(
                                    paymentDateStart.format('YYYY-MM-DD'),
                                    paymentDateEnd.format('YYYY-MM-DD')
                                )}
                                loading={paymentsLoading}
                            >
                                Getir
                            </Button>
                            <Button
                                type="default"
                                onClick={() => {
                                }}
                            >
                                Excel
                            </Button>
                            <Button
                                type="primary"
                                onClick={() => handleOpenForm(
                                    239,
                                    'Ödeme Kaydı Oluştur',
                                    'odm_taksit',
                                    'id',
                                    null,
                                    {
                                        ekleyen: user?.kullanici_no || null,
                                        eklenme_tarihi: new Date().toISOString().split('T')[0]
                                    },
                                    'Insert'
                                )}
                            >
                                Ödeme Kaydı Oluştur
                            </Button>
                        </Space>
                    </div>
                    <Input
                        placeholder="Ara (Cari, Firma, Açıklama)..."
                        prefix={<SearchOutlined />}
                        value={paymentSearchText}
                        onChange={(e) => setPaymentSearchText(e.target.value)}
                        allowClear
                    />
                    {paymentsLoading ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <Spin size="large" />
                        </div>
                    ) : payments.filter(payment => {
                        const cariAdi = payment.cariAdi !== 'Tanımsız' ? payment.cariAdi : `${payment.firma} / ${payment.hesapSahibi}`;
                        return (
                            trIncludes(cariAdi, paymentSearchText) ||
                            trIncludes(payment.firma, paymentSearchText) ||
                            trIncludes(payment.aciklama, paymentSearchText) ||
                            trIncludes(payment.onaylayan, paymentSearchText) ||
                            trIncludes(payment.ekleyen, paymentSearchText)
                        );
                    }).length > 0 ? (
                        <>
                            <Table
                                columns={paymentColumns}
                                scroll={{ x: 'max-content' }}
                                dataSource={payments.filter(payment => {
                                    const cariAdi = payment.cariAdi !== 'Tanımsız' ? payment.cariAdi : `${payment.firma} / ${payment.hesapSahibi}`;
                                    return (
                                        trIncludes(cariAdi, paymentSearchText) ||
                                        trIncludes(payment.firma, paymentSearchText) ||
                                        trIncludes(payment.aciklama, paymentSearchText) ||
                                        trIncludes(payment.onaylayan, paymentSearchText) ||
                                        trIncludes(payment.ekleyen, paymentSearchText)
                                    );
                                })}
                                pagination={{ pageSize: 10 }}
                                size="small"
                                rowKey="key"
                                className={darkMode ? 'dark-table' : ''}
                                rowClassName={(record) => record.durum ? 'green-row' : ''}
                            />
                            <div style={{ marginTop: 16, padding: '12px', backgroundColor: darkMode ? '#2a2a2a' : '#f5f5f5', borderRadius: 4 }}>
                                <Row gutter={16}>
                                    <Col xs={24} md={8}>
                                        <Text strong>Toplam Tutar: </Text>
                                        <Text style={{ color: darkMode ? '#fff' : undefined }}>
                                            {formatMoney(payments.reduce((sum, p) => sum + (parseFloat(p.tutar) || 0), 0))}
                                        </Text>
                                    </Col>
                                </Row>
                            </div>
                        </>
                    ) : (
                        <Empty description="Ödeme kaydı bulunamadı" />
                    )}
                </Space>
            </Modal>

            {/* Form Modal */}
            {formModalOpen && (
                <Modal
                    title={modalTitle}
                    open={formModalOpen}
                    onCancel={closeFormModal}
                    footer={null}
                    destroyOnClose={true}
                    width={800}
                    className={darkMode ? 'dark-modal' : ''}
                >
                    <div style={{ maxHeight: 600, overflowY: 'auto' }}>
                        <FormikForm
                            formId={currentFormId}
                            uniqueValue={currentUniqueValue}
                            uniqueField={formUniqueField}
                            tableName={formTableName}
                            extraData={formExtraData}
                            onSuccess={handleFormSuccess}
                        />
                    </div>
                </Modal>
            )}

        </div>
    );
};

export default PersonelPage;
